import { render, staticRenderFns } from "./detailTable17.vue?vue&type=template&id=3e4c8a97&scoped=true"
import script from "./detailTable17.vue?vue&type=script&lang=js"
export * from "./detailTable17.vue?vue&type=script&lang=js"
import style0 from "./detailTable17.vue?vue&type=style&index=0&id=3e4c8a97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4c8a97",
  null
  
)

export default component.exports